var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "offcanvas mobile-filter is-left" },
    [
      _c(
        "button",
        {
          staticClass: "btn btn-block offcanvas-close",
          on: {
            click: function($event) {
              return _vm.closeFilter()
            }
          }
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$translate("Ceres::Template.itemFilter")) +
              "\n        "
          ),
          _c(
            "svg",
            {
              staticClass: "icon icon-x",
              attrs: { width: "32", height: "32", fill: "currentColor" }
            },
            [_c("use", { attrs: { "xlink:href": "#x" } })]
          )
        ]
      ),
      _vm._v(" "),
      _c("portal-target", {
        staticClass: "offcanvas-content-container",
        attrs: { name: "mobile-filter" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }